import { dedupe, KeyAndScale } from '@arpeggi/shared'
import { useMemo } from 'react'
import { useMedia } from './useMedia'

export const useTags = () => {
  const { metadata } = useMedia()
  const displayTags = useMemo(() => {
    const { tags, bpm, genres, key } = metadata
    const result = [...tags, ...genres]
    result.push(`Key: ${KeyAndScale.from(key).displayName()}`)
    if (bpm) result.push(`${bpm} bpm`)
    return dedupe(result)
  }, [metadata])
  return displayTags
}
